<template>
  <a-tabs defaultActiveKey="1">
    <a-tab-pane tab="Control Cargue Novedades" key="1">
      <g-master :name="master.endpoint"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
      >
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Fecha Apertura')" v-bind="fiOptions">
                <a-date-picker style="width: 100%"
                               type="date"
                               valueFormat="Y-MM-DD 00:00:00"
                               v-decorator="['crg_fecha_ape', { rules: [{ required: true, message: 'Valor requerido' }] }]"></a-date-picker>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Fecha Cierre')" v-bind="fiOptions">
                <a-date-picker style="width: 100%"
                               type="date"
                               valueFormat="Y-MM-DD 00:00:00"
                               v-decorator="['crg_fecha_cie', { rules: [{ required: true, message: 'Valor requerido' }] }]"></a-date-picker>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown v-bind="fiOptions"
                          endpoint="hierarchy_lookup"
                          :label="$t('Estado')"
                          :formItemConfig="fiOptions"
                          :decorator="['crg_estado', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                          :params="estado">
              </g-dropdown>
            </a-col>
          </a-row>
        </template>
      </g-master>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
  export default {
    data () {
      return {
        pageTitle: 'Control Cargue Novedades',
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 24},
        estado: {
          h_lookup_type: 'ESTADO_ACT_INA',
          use_code: true
        },
        master: {
          endpoint: 'ctl_nov_crg',
          tableSetup: {
            actions: {
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'}
                }
              ]
            },
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Fecha apertura', dataIndex: 'crg_fecha_ape', sorter: true},
              {title: 'Fecha cierre', dataIndex: 'crg_fecha_cie', sorter: true},
              {title: 'Estado', dataIndex: 'crg_estado', sorter: true},
              {title: 'Tipo Cierre', dataIndex: 'tipo_cierre', sorter: true},
              {title: 'Creado Por', dataIndex: 'username', sorter: true},
              {title: 'Creado El', dataIndex: 'fecha_sistema', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'crg_fecha_ape'},
            {name: 'crg_fecha_cie'},
            {name: 'crg_estado'}
          ]
        }
      }
    },
    methods: {
      /*      masterAction (action) {
              switch (action.action) {
                case 'masterEdit':
                  if (!this.$isEmpty(action.record.con_codigo)) {
                    this.$refs.concepto && this.$refs.concepto.handleSearch(action.record.con_codigo)
                  }
                  break
              }
            } */
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Novedades/CtlNovCrg.vue